<template>
  <router-btn :info="$t('servicesystem.common_objects.commonterms.copy')" :icon="'mdi-content-copy'" :color="'primary'"
    :disabled="false" outlined :textbtn="textbtn" :large="large" :small="small" @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "CopyJobBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  created() { },

  mounted() { },

  methods: {
    action() {
      this.$store.dispatch("JobHub/JobParentjob/copyjob");
      this.$router.push({ name: "NewJobOverview" });
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped></style>
